<p-stepper [(value)]="activeStep" class="block w-full max-w-4xl mx-auto">
    <p-step-list>
        <p-step [value]="1">
            <i class="ph ph-buildings mr-1.5"></i>
            {{ 'FUNPAY_STEP_BUSINESS' | translate }}
        </p-step>
        <p-step [value]="2">
            <i class="ph ph-storefront mr-1.5"></i>
            {{ 'FUNPAY_STEP_VENUE' | translate }}
        </p-step>
        <p-step [value]="3">
            <i class="ph ph-check-square-offset mr-1.5"></i>
            {{ 'FUNPAY_STEP_REVIEW' | translate }}
        </p-step>
    </p-step-list>

    <p-step-panels class="mt-6 bg-card p-6 rounded-lg">
        <!-- STEP 1: THE LEGAL ENTITY ADYEN WILL VET -->
        <p-step-panel [value]="1">
            <ng-template #content>
                <p class="mb-4 text-sm text-text-2">{{ 'FUNPAY_STEP_BUSINESS_HELP' | translate }}</p>

                <section class="grid gap-4 grid-cols-1 md:grid-cols-2">
                    <!-- Registered legal name -->
                    <div class="flex flex-col gap-1 md:col-span-2">
                        <p-floatlabel variant="on">
                            <input
                                type="text"
                                size="large"
                                pInputText
                                [formField]="onboardingForm.legalName"
                                [ngClass]="{
                                    'ng-invalid ng-dirty': onboardingForm.legalName().invalid() && onboardingForm.legalName().touched()
                                }"
                                class="w-full" />
                            <label class="text-sm font-medium">{{ 'FUNPAY_LEGAL_NAME' | translate }}</label>
                        </p-floatlabel>
                        @if (onboardingForm.legalName().invalid() && onboardingForm.legalName().touched()) {
                        <small class="text-red-500 flex items-center gap-1">
                            <i class="ph ph-warning-circle"></i>
                            {{ fieldError(onboardingForm.legalName()) | translate }}
                        </small>
                        } @else {
                        <small class="text-text-muted">{{ 'FUNPAY_LEGAL_NAME_HELP' | translate }}</small>
                        }
                    </div>

                    <!-- What the venue trades as -->
                    <div class="flex flex-col gap-1">
                        <p-floatlabel variant="on">
                            <p-select
                                appendTo="body"
                                class="w-full"
                                size="large"
                                optionLabel="label"
                                optionValue="value"
                                [options]="industryOptions()"
                                [ngModel]="onboardingData().industryCode"
                                (ngModelChange)="setIndustryCode($event)"
                                [disabled]="submitting()">
                                <ng-template #dropdownicon><i class="ph ph-caret-down"></i></ng-template>
                            </p-select>
                            <label class="text-sm font-medium">{{ 'FUNPAY_INDUSTRY' | translate }}</label>
                        </p-floatlabel>
                        <small class="text-text-muted">{{ 'FUNPAY_INDUSTRY_HELP' | translate }}</small>
                    </div>

                    <!-- Signatory phone -->
                    <div class="flex flex-col gap-1">
                        <p-floatlabel variant="on">
                            <input
                                type="tel"
                                size="large"
                                pInputText
                                [formField]="onboardingForm.phoneNumberSignatory"
                                [ngClass]="{
                                    'ng-invalid ng-dirty':
                                        onboardingForm.phoneNumberSignatory().invalid() && onboardingForm.phoneNumberSignatory().touched()
                                }"
                                class="w-full" />
                            <label class="text-sm font-medium">{{ 'FUNPAY_SIGNATORY_PHONE' | translate }}</label>
                        </p-floatlabel>
                        @if (onboardingForm.phoneNumberSignatory().invalid() && onboardingForm.phoneNumberSignatory().touched()) {
                        <small class="text-red-500 flex items-center gap-1">
                            <i class="ph ph-warning-circle"></i>
                            {{ fieldError(onboardingForm.phoneNumberSignatory()) | translate }}
                        </small>
                        } @else {
                        <small class="text-text-muted">{{ 'FUNPAY_SIGNATORY_PHONE_HELP' | translate }}</small>
                        }
                    </div>
                </section>

                <footer class="mt-6 flex justify-end">
                    <button pButton type="button" [disabled]="!businessStepValid()" (click)="goToStep(2)">
                        {{ 'FUNPAY_NEXT' | translate }}
                        <i class="ph ph-arrow-right ml-1.5"></i>
                    </button>
                </footer>
            </ng-template>
        </p-step-panel>

        <!-- STEP 2: HOW THE VENUE APPEARS TO ITS CUSTOMERS -->
        <p-step-panel [value]="2">
            <ng-template #content>
                <p class="mb-4 text-sm text-text-2">{{ 'FUNPAY_STEP_VENUE_HELP' | translate }}</p>

                <section class="grid gap-4 grid-cols-1 md:grid-cols-2">
                    <!-- Bank statement descriptor -->
                    <div class="flex flex-col gap-1">
                        <p-floatlabel variant="on">
                            <input
                                type="text"
                                size="large"
                                pInputText
                                [formField]="onboardingForm.shopperStatement"
                                [ngClass]="{
                                    'ng-invalid ng-dirty':
                                        onboardingForm.shopperStatement().invalid() && onboardingForm.shopperStatement().touched()
                                }"
                                class="w-full" />
                            <label class="text-sm font-medium">{{ 'FUNPAY_SHOPPER_STATEMENT' | translate }}</label>
                        </p-floatlabel>
                        @if (onboardingForm.shopperStatement().invalid() && onboardingForm.shopperStatement().touched()) {
                        <small class="text-red-500 flex items-center gap-1">
                            <i class="ph ph-warning-circle"></i>
                            {{ fieldError(onboardingForm.shopperStatement()) | translate }}
                        </small>
                        } @else {
                        <small class="text-text-muted">
                            {{ 'FUNPAY_SHOPPER_STATEMENT_HELP' | translate }} ({{ shopperStatementLength() }}/{{ shopperStatementMaxLength
                            }})
                        </small>
                        }
                    </div>

                    <!-- Venue phone -->
                    <div class="flex flex-col gap-1">
                        <p-floatlabel variant="on">
                            <input
                                type="tel"
                                size="large"
                                pInputText
                                [formField]="onboardingForm.phoneNumberVenue"
                                [ngClass]="{
                                    'ng-invalid ng-dirty':
                                        onboardingForm.phoneNumberVenue().invalid() && onboardingForm.phoneNumberVenue().touched()
                                }"
                                class="w-full" />
                            <label class="text-sm font-medium">{{ 'FUNPAY_VENUE_PHONE' | translate }}</label>
                        </p-floatlabel>
                        @if (onboardingForm.phoneNumberVenue().invalid() && onboardingForm.phoneNumberVenue().touched()) {
                        <small class="text-red-500 flex items-center gap-1">
                            <i class="ph ph-warning-circle"></i>
                            {{ fieldError(onboardingForm.phoneNumberVenue()) | translate }}
                        </small>
                        } @else {
                        <small class="text-text-muted">{{ 'FUNPAY_VENUE_PHONE_HELP' | translate }}</small>
                        }
                    </div>

                    <!-- The premises: registered address on the legal entity, and the store address -->
                    <div class="flex flex-col gap-1 md:col-span-2">
                        <p-floatlabel variant="on">
                            <input
                                type="text"
                                size="large"
                                pInputText
                                [formField]="onboardingForm.street"
                                [ngClass]="{
                                    'ng-invalid ng-dirty': onboardingForm.street().invalid() && onboardingForm.street().touched()
                                }"
                                class="w-full" />
                            <label class="text-sm font-medium">{{ 'FUNPAY_STREET' | translate }}</label>
                        </p-floatlabel>
                        @if (onboardingForm.street().invalid() && onboardingForm.street().touched()) {
                        <small class="text-red-500 flex items-center gap-1">
                            <i class="ph ph-warning-circle"></i>
                            {{ fieldError(onboardingForm.street()) | translate }}
                        </small>
                        } @else {
                        <small class="text-text-muted">{{ 'FUNPAY_STREET_HELP' | translate }}</small>
                        }
                    </div>

                    <div class="flex flex-col gap-1">
                        <p-floatlabel variant="on">
                            <input
                                type="text"
                                size="large"
                                pInputText
                                [formField]="onboardingForm.postalCode"
                                [ngClass]="{
                                    'ng-invalid ng-dirty': onboardingForm.postalCode().invalid() && onboardingForm.postalCode().touched()
                                }"
                                class="w-full" />
                            <label class="text-sm font-medium">{{ 'FUNPAY_POSTAL_CODE' | translate }}</label>
                        </p-floatlabel>
                        @if (onboardingForm.postalCode().invalid() && onboardingForm.postalCode().touched()) {
                        <small class="text-red-500 flex items-center gap-1">
                            <i class="ph ph-warning-circle"></i>
                            {{ fieldError(onboardingForm.postalCode()) | translate }}
                        </small>
                        } @else {
                        <small class="text-text-muted">{{ 'FUNPAY_POSTAL_CODE_HELP' | translate }}</small>
                        }
                    </div>

                    <div class="flex flex-col gap-1">
                        <p-floatlabel variant="on">
                            <input
                                type="text"
                                size="large"
                                pInputText
                                [formField]="onboardingForm.city"
                                [ngClass]="{
                                    'ng-invalid ng-dirty': onboardingForm.city().invalid() && onboardingForm.city().touched()
                                }"
                                class="w-full" />
                            <label class="text-sm font-medium">{{ 'FUNPAY_CITY' | translate }}</label>
                        </p-floatlabel>
                        @if (onboardingForm.city().invalid() && onboardingForm.city().touched()) {
                        <small class="text-red-500 flex items-center gap-1">
                            <i class="ph ph-warning-circle"></i>
                            {{ fieldError(onboardingForm.city()) | translate }}
                        </small>
                        } @else {
                        <small class="text-text-muted">{{ 'FUNPAY_CITY_HELP' | translate }}</small>
                        }
                    </div>

                    @if (stateRequired()) {
                    <div class="flex flex-col gap-1 md:col-span-2">
                        <p-floatlabel variant="on">
                            <input
                                type="text"
                                size="large"
                                pInputText
                                [formField]="onboardingForm.stateOrProvince"
                                [ngClass]="{
                                    'ng-invalid ng-dirty': onboardingForm.stateOrProvince().invalid() && onboardingForm.stateOrProvince().touched()
                                }"
                                class="w-full" />
                            <label class="text-sm font-medium">{{ 'FUNPAY_STATE' | translate }}</label>
                        </p-floatlabel>
                        @if (onboardingForm.stateOrProvince().invalid() && onboardingForm.stateOrProvince().touched()) {
                        <small class="text-red-500 flex items-center gap-1">
                            <i class="ph ph-warning-circle"></i>
                            {{ fieldError(onboardingForm.stateOrProvince()) | translate }}
                        </small>
                        } @else {
                        <small class="text-text-muted">{{ 'FUNPAY_STATE_HELP' | translate }}</small>
                        }
                    </div>
                    }
                </section>

                <footer class="mt-6 flex justify-between">
                    <button pButton type="button" [text]="true" (click)="goToStep(1)">
                        <i class="ph ph-arrow-left mr-1.5"></i>
                        {{ 'FUNPAY_BACK' | translate }}
                    </button>
                    <button pButton type="button" [disabled]="!venueStepValid()" (click)="goToStep(3)">
                        {{ 'FUNPAY_NEXT' | translate }}
                        <i class="ph ph-arrow-right ml-1.5"></i>
                    </button>
                </footer>
            </ng-template>
        </p-step-panel>

        <!-- STEP 3: CONFIRM, THEN HAND OVER TO ADYEN -->
        <p-step-panel [value]="3">
            <ng-template #content>
                @let data = onboardingData();

                <p class="mb-4 text-sm text-text-2">{{ 'FUNPAY_STEP_REVIEW_HELP' | translate }}</p>

                <dl class="grid grid-cols-1 gap-3 sm:grid-cols-2">
                    <div class="flex flex-col">
                        <dt class="text-sm text-text-muted">{{ 'FUNPAY_LEGAL_NAME' | translate }}</dt>
                        <dd class="m-0 font-medium text-text">{{ data.legalName }}</dd>
                    </div>
                    <div class="flex flex-col">
                        <dt class="text-sm text-text-muted">{{ 'FUNPAY_INDUSTRY' | translate }}</dt>
                        <dd class="m-0 font-medium text-text">{{ selectedIndustryLabel() }}</dd>
                    </div>
                    <div class="flex flex-col">
                        <dt class="text-sm text-text-muted">{{ 'FUNPAY_SHOPPER_STATEMENT' | translate }}</dt>
                        <dd class="m-0 font-medium text-text">{{ data.shopperStatement }}</dd>
                    </div>
                    <div class="flex flex-col">
                        <dt class="text-sm text-text-muted">{{ 'FUNPAY_VENUE_PHONE' | translate }}</dt>
                        <dd class="m-0 font-medium text-text">{{ data.phoneNumberVenue }}</dd>
                    </div>
                    @if (data.phoneNumberSignatory) {
                    <div class="flex flex-col">
                        <dt class="text-sm text-text-muted">{{ 'FUNPAY_SIGNATORY_PHONE' | translate }}</dt>
                        <dd class="m-0 font-medium text-text">{{ data.phoneNumberSignatory }}</dd>
                    </div>
                    }
                    <div class="flex flex-col sm:col-span-2">
                        <dt class="text-sm text-text-muted">{{ 'FUNPAY_ADDRESS' | translate }}</dt>
                        <dd class="m-0 font-medium text-text">
                            {{ data.street }}, {{ data.postalCode }} {{ data.city }}@if (data.stateOrProvince) {
                            <span>, {{ data.stateOrProvince }}</span>
                            }
                        </dd>
                    </div>
                    @if (prefill()?.country) {
                    <div class="flex flex-col">
                        <dt class="text-sm text-text-muted">{{ 'FUNPAY_REGISTERED_COUNTRY' | translate }}</dt>
                        <dd class="m-0 font-medium text-text">{{ prefill()?.country }}</dd>
                    </div>
                    }
                </dl>

                <p class="mt-6 text-sm text-text-2">{{ 'FUNPAY_REVIEW_HANDOVER' | translate }}</p>

                @if (submitError()) {
                <p class="mt-4 flex items-center gap-2 rounded-md bg-red-500/10 p-3 text-sm text-red-500">
                    <i class="ph ph-warning-circle"></i>
                    {{ submitError() | translate }}
                </p>
                }

                <footer class="mt-6 flex justify-between">
                    <button pButton type="button" [text]="true" [disabled]="submitting()" (click)="goToStep(2)">
                        <i class="ph ph-arrow-left mr-1.5"></i>
                        {{ 'FUNPAY_BACK' | translate }}
                    </button>
                    <button pButton type="button" [loading]="submitting()" [disabled]="!formValid() || submitting()" (click)="submit()">
                        <i class="ph ph-paper-plane-tilt mr-1.5"></i>
                        {{ 'FUNPAY_START_APPLICATION' | translate }}
                    </button>
                </footer>
            </ng-template>
        </p-step-panel>
    </p-step-panels>
</p-stepper>
